import { signAttachmentsService, attachmentsServiceV2, storeSendsReceiptService } from 'config/api';
import { resetActiveUserADGroup, checkAttachmentsLimit } from 'modules/shell/actions';
import { uuidv4 } from 'utils/commonUtils';
import _isEmpty from 'lodash/isEmpty';
import actionTypes from './actionTypes';
import { getSecondsTimestamp } from '../../clienteling/utils';

export const addCloudinaryBarcode =
  (cloudinaryConfig, attachments = [], barcode) =>
  async (dispatch) => {
    const isFileAttachments = attachments.filter(_isEmpty).length === attachments.length;
    if (isFileAttachments) {
      const attachmentsAtLimit = await dispatch(checkAttachmentsLimit(attachments, isFileAttachments));

      if (attachmentsAtLimit) return;
    }

    //* we have to resetAdGroup so it does not get requests header
    resetActiveUserADGroup();

    const { cloudName, apiKey } = cloudinaryConfig;
    const checkedAttachments = attachments.map((item) => ({ id: uuidv4(), item }));

    dispatch({
      type: actionTypes.UPLOAD_SENDS_BARCODE_LOADING,
    });

    try {
      const timestamp = getSecondsTimestamp();
      const folder = 'OSP/sendsBarcodes';

      const publicIds = [`${folder}/barcode${barcode}`];
      const { data: signatures } = await signAttachmentsService.post('', { timestamp, publicIds });

      const fd = new FormData();
      const resourceType = 'auto';

      fd.append('api_key', apiKey);
      fd.append('cloud_name', cloudName);
      fd.append('timestamp', timestamp);
      fd.append('signature', signatures[0].signature);
      fd.append('public_id', publicIds[0]);
      fd.append('file', checkedAttachments[0].item);

      const res = await attachmentsServiceV2.post(`${cloudName}/${resourceType}/upload`, fd);

      dispatch({
        type: actionTypes.UPLOAD_SENDS_BARCODE_SUCCESS,
        payload: res?.data?.url || res?.data?.secure_url,
      });
    } catch (error) {
      dispatch({ type: actionTypes.UPLOAD_SENDS_BARCODE_ERROR, payload: error });
    }
  };

export const triggerSendStoreReceipt =
  ({ orderId, deliveryReceiptNumber, barcodeURL }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.SENDS_EMAIL_RECEIPT_LOADING,
    });

    try {
      const res = await storeSendsReceiptService.post('/delivery', {
        orderId,
        deliveryReceiptNumber,
        barcodeURL,
      });
      dispatch({
        type: actionTypes.SENDS_EMAIL_RECEIPT_SUCCESS,
        payload: res?.data.message,
      });
    } catch (error) {
      dispatch({
        type: actionTypes.SENDS_EMAIL_RECEIPT_ERROR,
        payload: error,
      });
    }
  };

export const clearSendsReceiptBarcode = () => ({
  type: actionTypes.UPLOAD_SENDS_BARCODE_CLEAR,
});
